enum currency {
  EUR = '€',
  ILS = '₪',
  RUB = '₽',
  USD = '$'
}

export default currency
